import { useTranslation } from 'react-i18next';

import Picture from 'components/desktop/Accessory/Search/Components/SearchResultListRow/Picture';
import BtnGroup, { BtnData } from 'components/desktop/_general/Button/BtnGroup/BtnGroup';
import FormatedDate from 'components/desktop/_general/FormatedDate/FormatedDate';
import IconComponent from 'components/desktop/_general/Icon/IconComponent';
import IconCo2Round from 'components/desktop/_general/IconCo2/IconCo2Round';
import * as Accessory from 'types/Accessory/Search/Accessory';
import * as Icon from 'types/Icon/Icon';

interface IProps {
	accessory: Accessory.Type;
	handleRestoreAccessory: (input: string) => Promise<void>;
}

const ArchiveResultListRow = (props: IProps) => {
	const { t } = useTranslation();

	const getButtonDataRestore = (): BtnData => {
		return {
			onClick: () => props.handleRestoreAccessory(props.accessory.id),
		};
	};

	const renderButtons = (): JSX.Element => {
		return <BtnGroup restore={getButtonDataRestore()} />;
	};

	return (
		<div className="recipe-table-item" key={props.accessory.name}>
			<Picture image={props.accessory.image} />
			<div id="column-first">
				<div id="title">
					<strong>{props.accessory.name}</strong>
				</div>
			</div>
			<div id="column-second">
				<div className="row">
					<div className="col-5">
						<span className="grey">{t('_general:LAST_CHANGE_DATE')}:</span>
						<br />
						<span className="grey">{t('_general:LAST_EDITOR')}:</span>
						<br />
					</div>
					<div className="col-7">
						<FormatedDate date={props.accessory.lastEditedDateUtc} />
						<br />
						<span>{Accessory.getAuthor(props.accessory)}</span>
					</div>
				</div>
			</div>
			<div id="column-last">
				<div id="icon-rows">
					{Accessory.getIcons(props.accessory)
						.slice(0, 4)
						.map((icon: Icon.Type, i: number) => (
							<IconComponent icon={icon} key={i} />
						))}
					<IconCo2Round
						color={
							props.accessory.carbonDioxideLabel
								? props.accessory.carbonDioxideLabel.color!
								: ''
						}
						label={
							props.accessory.carbonDioxideLabel
								? props.accessory.carbonDioxideLabel.label!
								: ''
						}
					/>
				</div>
				<div>{renderButtons()}</div>
			</div>
		</div>
	);
};

export default ArchiveResultListRow;
